import { BasicEntityWatcher } from "../Services/DataService/EntityWatcher";
import { DataEntityBase } from "../Services/DataService/Model";
import { IConstructorOptions } from "../Utilities";
import { BaseViewModel } from "./Base/BaseViewModel";
import { DailyEntryViewModel } from "./DailyEntryViewModel";
import { GetCorrelation, ICorrelation } from "./Utilities";





export class ScoreTrendViewModel extends BaseViewModel {

    public static GetModel() {
        if (this._instance === undefined)
            this._instance = new ScoreTrendViewModel();
        return this._instance;
    }
    private static _instance: ScoreTrendViewModel | undefined = undefined;

    public get ShowPlaceholder() {

        return this._weeklyAverages.length < 3;
    }

    public get ChartData() {

        var retVal: {
            label: string;
            data: {
                x: string;
                y: number;
            }[];
            fill: boolean;
            borderColor: string;
            tension: number;
            pointStyle: boolean;
        }[] = [];

        if (this._weeklyAverages.length >= 3) {
            retVal.push(
                {
                    label: 'Weekly Trend',
                    data: this._weeklyAverages.map((label) => ({
                        x: label.date.toISOString(), // Timestamp (already in milliseconds)
                        y: label.score, // Corresponding score
                    })),
                    fill: false,
                    borderColor: "#669E72",
                    tension: 0.3,
                    pointStyle: false
                }
            );
        }

        if (this._monthlyAverages.length > 3) {
            retVal.push(
                {
                    label: 'Monthly Trend',
                    data: this._monthlyAverages.map((label) => ({
                        x: label.date.toISOString(), // Timestamp (already in milliseconds)
                        y: label.score, // Corresponding score
                    })),
                    fill: false,
                    borderColor: "#4E2B10",
                    tension: 0.3,
                    pointStyle: false
                }
            );
        }

        return { datasets: retVal };
    }



    protected async doHydrate(correlation: ICorrelation) {
        await this.updateTrendData(correlation);

        DailyEntryViewModel.Manager.EntitiesChanged.Subscribe(() => {
            this.updateTrendData(GetCorrelation());
        });
    }



    private async updateTrendData(correlation?: ICorrelation) {

        let _correlation = correlation ?? GetCorrelation();
        var dailyEntries = await DailyEntryViewModel.Manager.GetAllItems(_correlation);
        this._dailyScores = [];

        let completedEntries = dailyEntries.filter((entry) => entry.TypedData.status === 'Complete');
        this._dailyScores = completedEntries.map((entry) => ({
            date: entry.TypedData.date,
            score: entry.TypedData.score
        }));
        this._weeklyAverages = this.calculateMovingAverage(7);
        this._monthlyAverages = this.calculateMovingAverage(28);
        this.FireChanged("ChartData");
    }

    private calculateMovingAverage(period: number) {
        const movingAverageData = [];

        // Sort trendData by date to ensure it's in chronological order
        this._dailyScores.sort((a, b) => a.date.getTime() - b.date.getTime());

        for (let i = 0; i < this._dailyScores.length; i++) {
            let sum = 0;
            let count = 0;

            // Get the current date
            const currentDate = this._dailyScores[i].date;

            // Calculate the start date for the moving average window
            const startDate = new Date(currentDate);
            startDate.setDate(startDate.getDate() - period + 1); // Calculate the start of the period

            // Skip calculation if the startDate is before the first available date in trendData
            if (startDate < this._dailyScores[0].date) {
                continue; // Skip the first few days where there's not enough data
            }

            // Iterate through the trendData to accumulate scores within the date range
            for (let j = 0; j < this._dailyScores.length; j++) {
                const entryDate = this._dailyScores[j].date;

                // Only accumulate scores within the range, or until we hit the current date
                if (entryDate >= startDate && entryDate <= currentDate) {
                    sum += this._dailyScores[j].score;
                    count++;
                }
            }

            // Ensure that we calculate the moving average only if there are any data points
            if (count > 0) {
                const avgScore = sum / count; // Calculate the average score for the window
                movingAverageData.push({
                    date: currentDate, // Use the same date as the current entry
                    score: avgScore
                });
            }
        }

        return movingAverageData; // Return the calculated moving averages
    }


    protected CreateData(_watcher: BasicEntityWatcher, _options?: IConstructorOptions): DataEntityBase {
        return {} as any;
    }

    private constructor() {
        super()
    }




    private _dailyScores: { date: Date, score: number }[] = [];
    private _weeklyAverages: { date: Date, score: number }[] = [];
    private _monthlyAverages: { date: Date, score: number }[] = [];

}